import React from 'react'
import Icon from 'react-icon-base'

const SearchIcon = props => (
  <Icon viewBox="0 0 40 40" {...props}>
    <g>
      <g>
        <path d="m15.9 23.4c4.1 0 7.5-3.4 7.5-7.5s-3.4-7.5-7.5-7.5-7.5 3.3-7.5 7.5 3.3 7.5 7.5 7.5z m10 0l8.2 8.2-2.5 2.5-8.2-8.2v-1.4l-0.5-0.4c-1.9 1.6-4.4 2.5-7 2.5-6.1 0-10.9-4.7-10.9-10.7s4.8-10.9 10.9-10.9 10.7 4.8 10.7 10.9c0 2.6-0.9 5.1-2.5 7l0.4 0.5h1.4z" />
      </g>
    </g>
  </Icon>
)

export default SearchIcon
